export default __webpack_public_path__ + "static/media/sports_contact.0c373cdc.png";